import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaypal = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "1em",
	height: "1em",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "PayPal Icon (1) 2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M12.101 2.07576C11.4669 1.35305 10.3207 1.04321 8.85443 1.04321H4.59884C4.45376 1.04322 4.31344 1.09498 4.20312 1.18918C4.09279 1.28339 4.01968 1.41386 3.99695 1.55714L2.225 12.7953C2.18978 13.0169 2.36137 13.2176 2.58598 13.2176H5.21324L5.87306 9.03246L5.85258 9.16352C5.89959 8.86769 6.15259 8.6495 6.45219 8.6495H7.70066C10.1533 8.6495 12.0737 7.65331 12.6347 4.77154C12.6513 4.68631 12.6658 4.60336 12.6782 4.52232C12.6074 4.48482 12.6074 4.48482 12.6782 4.52232C12.8453 3.45719 12.6771 2.73216 12.101 2.07576Z",
				fill: "var(--fill-0, #27346A)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M6.87833 4.13861C6.95015 4.10441 7.02871 4.08668 7.10826 4.08673H10.4446C10.8396 4.08673 11.2081 4.11244 11.5449 4.16664C11.6391 4.18166 11.7328 4.1996 11.8259 4.22042C11.9579 4.24955 12.0884 4.28519 12.2168 4.32722C12.3824 4.38251 12.5365 4.4469 12.6782 4.5223C12.8452 3.45677 12.6771 2.73216 12.1009 2.07575C11.4665 1.35305 10.3207 1.04321 8.8544 1.04321H4.59846C4.29882 1.04321 4.0439 1.26136 3.99694 1.55714L2.225 12.7948C2.18978 13.0168 2.36137 13.2172 2.58562 13.2172H5.21323L6.58214 4.53632C6.5956 4.45099 6.62959 4.37021 6.68118 4.30093C6.73278 4.23165 6.80043 4.17595 6.87833 4.13861Z",
				fill: "var(--fill-0, #27346A)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M12.8561 5.33525C12.3128 8.12578 10.4529 9.09097 8.07759 9.09097H6.86812C6.57796 9.09097 6.33289 9.30228 6.2878 9.58879L5.49282 14.6285C5.46312 14.8163 5.60837 14.9865 5.7984 14.9865H7.94331C8.06617 14.9864 8.185 14.9426 8.27841 14.8628C8.37182 14.7829 8.43369 14.6724 8.45289 14.5511L8.47378 14.4418L8.87804 11.8797L8.90408 11.7381C8.92329 11.6167 8.98515 11.5062 9.07855 11.4264C9.17195 11.3466 9.29077 11.3027 9.41363 11.3027H9.73463C11.8124 11.3027 13.4394 10.4586 13.9148 8.01724C14.1132 6.99701 14.0106 6.14521 13.4856 5.54692C13.3264 5.3657 13.1286 5.21604 12.8983 5.09387C12.8858 5.17276 12.8723 5.2527 12.8561 5.33525Z",
				fill: "var(--fill-0, #2790C3)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M11.2552 4.74192C11.1878 4.72225 11.1198 4.70483 11.0512 4.68969C10.9795 4.67391 10.9073 4.66019 10.8347 4.64854C10.575 4.60651 10.2914 4.58667 9.98676 4.58667H7.41701C7.35569 4.58653 7.29512 4.6003 7.23989 4.62695C7.17982 4.65562 7.12764 4.69851 7.08788 4.75189C7.04811 4.80528 7.02196 4.86755 7.01169 4.93332L6.46548 8.39655L6.44971 8.49751C6.48564 8.26962 6.68054 8.10154 6.91136 8.10154H7.87338C9.7627 8.10154 11.242 7.33414 11.6742 5.11423C11.687 5.04857 11.6978 4.98495 11.7078 4.92224C11.5983 4.86447 11.4799 4.81455 11.3523 4.77225C11.3201 4.76157 11.2878 4.75147 11.2552 4.74192",
				fill: "var(--fill-0, #1F264F)"
			})
		]
	})
});
export default SvgPaypal;
